/**
 * Router
 */
import React, { Fragment, useContext } from 'react';
import { Switch, Route, withRouter, useLocation } from 'react-router-dom';
import Wos from './without-sidemenu';
import Ws from './with-sidemenu';
import Can from './components/Can';
import AuthContext from './authContext';

import WarehouseAdminParcelsReceipt from './pages/warehouseAdminParcelsReceipt';
import WarehouseAdminCancelledOrders from './pages/canceledOeders/warehouseAdminIndex';
import Assignment from './pages/assignment';
import BundleDetails from './pages/bundleDetails';
import bundleLogs from './pages/bundleLogs';
import Bundles from './pages/bundles';
import CenterOrders from './pages/reports/centerOrders';
import Centers from './pages/centers';
import CentersStatistics from './pages/centerStatistics/index';
import CentersStatisticsDetails from './pages/centerStatistics/details';
import CurrentOrders from './pages/reports';
import DeliveryOrders from './pages/deliveryOrders';
import DriversWallet from './pages/driversWallet';
import DriversWalletCharge from './pages/driversWallet/charge';
import DriversWalletBulkCharge from './pages/driversWallet/bulkCharge';
import DriversWalletHistory from './pages/driversWalletHistory';
import Login from './pages/login';
import OrderDetails from './pages/orderDetails';
import OrderLogs from './pages/orderLogs';
import OrderPostReceipts from './pages/postOrders/print/receipt';
import Orders from './pages/orders';
import PostOrdersQueue from './pages/postOrderQueue/postOrderIndex';
import ParcelDetails from './pages/parcelDetails';
import ParcelInventoryItems from './pages/parcelInventoryItems';
import Parcels from './pages/parcels';
import ParcelLogs from './pages/parcelLogs';
import ParcelsReceipt from './pages/parcelsReceipt';
import ParcelsSender from './pages/parcelsSender';
import Partners from './pages/partners';
import Products from './pages/products';
import SkusInventoryDetails from './pages/warehouseInventory/skuInventoryDetails';
import UploadInfo from './pages/uploadInfo';
import Users from './pages/users';
import UsersHelpical from './pages/users/indexHelpical';
import WarehouseAssignUser from './pages/warehouseDetails/assign-user';
import WarehouseChildren from './pages/warehouseChildren';
import WarehouseDetails from './pages/warehouseDetails';
import WarehouseInventory from './pages/warehouseInventory';
import WarehouseInventoryDetails from './pages/warehouseInventory/warehouseInventoryDetails';
import WarehouseInventoryHistory from './pages/warehouseInventory/warehouseInventoryHistory';
import Warehouses from './pages/warehouses';
import PostOrders from './pages/orders/postOrderIndex';
import PostPrintLabels from './pages/postOrders/printLabel/receipt';
import SendPostOrders from './pages/postOrders/add';
import PartnerWarehouseInventory from './pages/partnerWarehouseInventory';
import PostOrderExitReceipt from './pages/postOrderQueue/components/exitRecipt';
import NonOrderPostIndex from './pages/orders/nonOrderPostIndex';
import NonPostOrderDetails from './pages/nonPostOrderDetails';
import PostOrder3PLDetails from './pages/postOrder3PLDetails';
import VipOrders from './pages/orders/vipOrder';
import Invoice from './pages/bill';
import InvoiceDetails from './pages/bill/components/details';
import Profile from './pages/profile';
import Messages from './pages/messages';
import Ticketing from './pages/ticketing';
import TicketDetails from './pages/ticketDetail';
import TicketingListView from './pages/ticketingList';
// Type
export type Routes = RouteInterface[];
export type RouteInterface = {
  component: Function;
  path: string;
  routes?: string;
};

// Const routes
export const routes: Routes = [
  {
    path: '/post-orders/receipts/:id',
    component: OrderPostReceipts,
    //wos
  },
  {
    path: '/orders/post/exit-receipts',
    component: PostOrderExitReceipt,
    //wos
  },
  {
    path: '/products/:partnerId',
    component: Products,
    //wos
  },
  {
    path: '/login',
    component: Login,
    //wos
  },
  {
    path: '/messages',
    component: Messages,
    //wos
  },
  {
    path: '/ticketing',
    component: Ticketing,
    //wos
  },
  {
    path: '/ticketing-list',
    component: TicketingListView,
    //wos
  },
  {
    path: '/ticketing/:id',
    component: TicketDetails,
    //wos
  },
  {
    path: '/orders',
    component: Orders,
  },
  {
    path: '/profile',
    component: Profile,
  },
  {
    path: '/nonPost-orders',
    component: NonOrderPostIndex,
  },
  {
    path: '/nonPost-orders/:id',
    component: NonPostOrderDetails,
  },
  {
    path: '/nonPost-orders/3pl-orders/:id',
    component: PostOrder3PLDetails,
  },
  {
    path: '/vip-orders/3pl-orders/:id',
    component: PostOrder3PLDetails,
  },
  {
    path: '/vip-orders',
    component: VipOrders,
  },
  {
    path: '/post-orders',
    component: PostOrders,
  },
  {
    path: '/post-orders-queue',
    component: PostOrdersQueue,
  },
  {
    path: '/post-orders/:id/send',
    component: SendPostOrders,
  },
  {
    path: '/orders/:id',
    component: OrderDetails,
  },
  {
    path: '/bundles',
    component: Bundles,
  },
  {
    path: '/bundles/:id',
    component: BundleDetails,
  },
  {
    path: '/assignment',
    component: Assignment,
  },
  {
    path: '/users',
    component: Users,
  },
  {
    path: '/helpicalusers',
    component: UsersHelpical,
  },
  {
    path: '/partners',
    component: Partners,
  },
  {
    path: '/centers',
    component: Centers,
  },
  {
    path: '/centers/:partnerId',
    component: Centers,
  },
  {
    path: '/products',
    component: Products,
  },
  {
    path: '/your-products',
    component: Products,
  },
  {
    path: '/warehouses',
    component: Warehouses,
  },
  {
    path: '/warehouses/details/:id',
    component: WarehouseDetails,
  },
  {
    path: '/warehouses/assign-user/:id',
    component: WarehouseAssignUser,
  },
  {
    path: '/warehouses/children/:warehousesId',
    component: WarehouseChildren,
  },
  {
    path: '/warehouses/inventory',
    component: WarehouseInventory,
  },
  {
    path: '/partner-warehouses/inventory',
    component: PartnerWarehouseInventory,
  },
  {
    path: '/warehouse-admin-canceled-orders',
    component: WarehouseAdminCancelledOrders,
  },
  {
    path: '/warehouses/inventory/:warehousesId',
    component: WarehouseInventoryDetails,
  },
  {
    path: '/warehouses/inventory/:warehousesId/log/:skuId',
    component: WarehouseInventoryHistory,
  },
  {
    path: '/skus/inventory/:skuId/:name',
    component: SkusInventoryDetails,
  },
  {
    path: '/centersStatistics',
    component: CentersStatistics,
  },
  {
    path: '/centersStatistics/details/:id/:nameCenter',
    component: CentersStatisticsDetails,
  },
  {
    path: '/upload-info',
    component: UploadInfo,
  },
  {
    path: '/drivers-wallet',
    component: DriversWallet,
  },
  {
    path: '/drivers-wallet/:id/charge',
    component: DriversWalletCharge,
  },
  {
    path: '/drivers-wallet/bulk-charge',
    component: DriversWalletBulkCharge,
  },
  {
    path: '/drivers-wallet/:id/history',
    component: DriversWalletHistory,
  },
  {
    path: '/orders/:id/allLogs',
    component: OrderLogs,
  },
  {
    path: '/bundles/:id/allLogs',
    component: bundleLogs,
  },
  {
    path: '/reports/current-orders',
    component: CurrentOrders,
  },
  {
    path: '/reports/center-orders/:centerId',
    component: CenterOrders,
  },
  {
    path: '/delivery-orders',
    component: DeliveryOrders,
  },
  {
    path: '/parcels',
    component: Parcels,
  },
  {
    path: '/parcels/:id/allLogs',
    component: ParcelLogs,
  },
  {
    path: '/post-print-labels/:id',
    component: PostPrintLabels,
  },
  {
    path: '/parcels/details/:id',
    component: ParcelDetails,
  },
  {
    path: '/warehouse-admin-parcels-receipts',
    component: WarehouseAdminParcelsReceipt,
  },
  {
    path: '/parcels-sender',
    component: ParcelsSender,
  },
  {
    path: '/parcels-sender/:id/allLogs',
    component: ParcelLogs,
  },
  {
    path: '/parcels-receipt',
    component: ParcelsReceipt,
  },
  {
    path: '/parcel/:id/inventory-items',
    component: ParcelInventoryItems,
  },
  {
    path: '/boxes',
    component: Parcels,
  },
  {
    path: '/invoice',
    component: Invoice,
  },
  {
    path: '/invoice/:id',
    component: InvoiceDetails,
  },
];
const Referee = () => {
  const { pathname } = useLocation();
  const filters: string[] = [
    '/login',
    '/post-orders/receipts/',
    '/orders/post/exit-receipts',
    '/products/',
    '/post-print-labels/',
    '/post-orders/post-receipt',
    '/deliver-driver-receipt',
  ];

  const wosidebare = filters.filter(route => {
    return pathname.includes(route);
  });
  return (
    <Fragment>
      <Switch>
        {wosidebare[0] == undefined ? (
          <Route path="/" component={Ws} />
        ) : (
          <Route path="/" component={Wos} />
        )}
      </Switch>
    </Fragment>
  );
};

export default withRouter(Referee);
const checkAuth = () => localStorage.getItem('token') !== null;
// A special wrapper for <Route> that knows how to
// handle "sub"-routes by passing them in a `routes`
// prop to the component it renders.
export function RouteWithSubRoutes(route: RouteInterface) {
  const authContext = useContext(AuthContext);
  return (
    <Can
      role={authContext.user.role}
      perform={route.path}
      yes={() => (
        <Route
          exact
          path={route.path}
          render={props => {
            if (!checkAuth()) {
              window.location.reload();
              props.history.push('/login');
            }
            return <route.component {...props} routes={route.routes} />;
          }}
        />
      )}
    />
  );
}
